export default "__VITE_ASSET__BxHYFbIN__"